import PopoverContainer from '../../../Components/UiKits/Popover'

export default function Popover() {
  return (
    <div className='page-body'>
        <PopoverContainer/>
    </div>
  )
}
